import React from "react";
import PropTypes from "prop-types";
import css from "../../css/listing/map.module.css";

class MapStatic extends React.PureComponent {
    render() {
        const { listing } = this.props;
        const point = `${listing.latitude},${listing.longitude}`;

        const mapUrl = new URL(
            "https://maps.googleapis.com/maps/api/staticmap"
        );
        mapUrl.searchParams.append("center", point);
        mapUrl.searchParams.append("zoom", "15");
        mapUrl.searchParams.append("size", "354x200");
        mapUrl.searchParams.append("key", process.env.GOOGLE_MAPS_KEY);
        mapUrl.searchParams.append("scale", "2");
        mapUrl.searchParams.append(
            "style",
            "feature:administrative|visibility:off"
        );
        mapUrl.searchParams.append("style", "feature:poi|visibility:off");
        mapUrl.searchParams.append(
            "markers",
            `icon:${process.env.CDN_PREFIX}/static/icons/map-pin2.png|${point}`
        );

        return (
            <div className={css.map}>
                <img alt="Map {listing.full_address}" src={mapUrl.href} />
            </div>
        );
    }
}

MapStatic.propTypes = {
    listing: PropTypes.object.isRequired,
};

export default MapStatic;
